import { useEffect } from "react";
import { useAppSelector } from "../../globalState/hooks";
import { LoginRootState } from "../../types/login";

const ChatBot = () => {
  const userDetails = useAppSelector(
    (state: LoginRootState) => state.authReducer.loginDetials
  );
  const [firstName, lastName] = userDetails.fullName
    ? userDetails.fullName.split(" ")
    : ["", ""];
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;

    if (userDetails.country === "UK") {
      // UK version of the script
      script.innerHTML = `
        window.ymConfig = {
          bot: "x1717491306493",
          host: "https://r5.cloud.yellow.ai",
            payload: {
            empID: "${userDetails.userId || ""}",
            mailID: "${userDetails.email || ""}",
            firstName: "${firstName || ""}",
            lastName: "${lastName || ""}",
            gender: "${userDetails.gender || ""}",
            designation: "${userDetails.designation || ""}",
            platform: "web",
            widgetVersion: "v2"
          }
        };

        (function() {
          var w = window,
              ic = w.YellowMessenger;
          if (typeof ic === "function") {
              ic("reattach_activator");
              ic("update", ymConfig);
          } else {
              var d = document,
                  i = function() { i.c(arguments); };
              function l() {
                  var e = d.createElement("script");
                  e.type = "text/javascript";
                  e.async = true;
                  e.src = "https://cdn.yellowmessenger.com/plugin/widget-v2/latest/dist/main.min.js";
                  var t = d.getElementsByTagName("script")[0];
                  t.parentNode.insertBefore(e, t);
              }
              i.q = [];
              i.c = function(e) { i.q.push(e); };
              w.YellowMessenger = i;
              l();
              if (w.attachEvent) {
                  w.attachEvent("onload", l);
              } else {
                  w.addEventListener("load", l, false);
              }
          }
        })();
      `;
    } else {
      script.innerHTML = `
        window.ymConfig = {
          bot: 'x1664513785576',
          host: 'https://cloud.yellow.ai',
          payload: {
            empID: "${userDetails.userId || ""}",
            mailID: "${userDetails.email || ""}",
            firstName: "${firstName || ""}",
            lastName: "${lastName || ""}",
            gender: "${userDetails.gender || ""}",
            designation: "${userDetails.designation || ""}",
            platform: "web",
            widgetVersion: "v2"
          }
        };

        (function() {
          var w = window,
            ic = w.YellowMessenger;
          if ("function" === typeof ic) {
            ic("reattach_activator");
            ic("update", ymConfig);
          } else {
            var d = document,
            i = function() {
              i.c(arguments)
            };

            function l() {
              var e = d.createElement("script");
              e.type = "text/javascript";
              e.async = true;
              e.src = "https://cdn.yellowmessenger.com/plugin/widget-v2/latest/dist/main.min.js";
              var t = d.getElementsByTagName("script")[0];
              t.parentNode.insertBefore(e, t);
            }

            i.q = [];
          i.c = function(e) {
            i.q.push(e);
          };
            w.YellowMessenger = i;
            l();
          }
        })();
      `;
    }

    document.body.appendChild(script);

    const style = document.createElement("style");
    style.innerHTML = `
      .ym-online-box {
        visibility: hidden !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.body.removeChild(script);
      document.head.removeChild(style);
    };
  }, [userDetails]);

  return null;
};

export default ChatBot;
